import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";

//Signal
import { firstSetup } from "../shared/signals/first-setup";

@Component({
	selector: "app-setup",
	templateUrl: "./setup.component.html",
	styleUrl: "./setup.component.scss",
	standalone: false,
})
export class SetupComponent implements OnInit {
	activeStep: number = 1;

	firstSetup = firstSetup;

	organizationForm: FormGroup;

	descriptionMax: number = 200;

	steps: any = [
		{
			key: 1,
			icon: ["fas", "handshake"],
		},
		{
			key: 2,
			icon: ["fas", "sitemap"],
		},
		{
			key: 3,
			icon: ["fas", "flag-checkered"],
		},
	];

	constructor(private router: Router, private fb: FormBuilder) {}

	ngOnInit(): void {
		this.organizationForm = this.fb.group({
			name: ["", Validators.required],
			description: "",
		});
	}

	finischSetup() {
		firstSetup.set(false);
		this.router.navigate(["/"]);
	}
}
